enum DATA_ITEM {
  PARTICIPANT_NAME,
  PARTICIPANT_NAME_WITH_NOTES,
  SCRIPT_TITLE,
  VIDEO_DESCRIPTION,
  VIDEO_CREATION_DATE,
  VIDEO_TITLE,
  VIDEO_FIRST_NOTE_OR_TITLE,
  QUESTION_OPTIONS,
  ANSWER,
}
export default DATA_ITEM;
